/* eslint-disable indent */
import React from 'react'

import premiumMassageImages from '../../static/images/massage/premium-massage'
import { Style } from './premium-massage-item.styles'

const { chevronRight, infoIcon, checkIcon, timeIcon } = premiumMassageImages

const PremiumMassageItem = ({
  options,
  shadow = false,
  border = false,
  imageAuto = false,
  padding = '20px 20px',
  imageSize = '109px',
  hover = false,
  onPressDetailWork,
  showDetailWork
}) => {
  const _renderTermsOfService = () => (
    <div className="description-detail-work">
      <h4 className="h4">{options.termsOfServiceTitle}</h4>
      {options.termsOfServiceDescription.map(item => (
        <div key={item.id} className="sub-description-detail-work">
          <img
            src={checkIcon}
            alt="halojasa/check-icon"
            className="icon-images"
          />
          <p key={item.id}>{item.title}</p>
        </div>
      ))}
    </div>
  )

  const _renderStandardEquiment = () => (
    <div className="description-detail-work">
      <h4 className="h4">{options.standardEquimentTitle}</h4>
      <p>{options.standardEquimentDescription}</p>
    </div>
  )

  const _renderCoverage = () => (
    <div className="description-detail-work">
      <h4 className="h4">{options.coverageServiceTitle}</h4>
      {options.coverageServiceDescription.map(item => (
        <div key={item.id} className="sub-description-detail-work">
          <img
            src={checkIcon}
            alt="halojasa/check-icon"
            className="icon-images"
          />
          <p key={item.id}>{item.title}</p>
        </div>
      ))}
    </div>
  )

  const _renderDuration = () => (
    <div className="description-detail-work">
      <h4 className="h4">{options.durationServiceTitle}</h4>
      <div className="sub-description-detail-work">
        <img src={timeIcon} alt="halojasa/time-icon" className="icon-images" />
        <p>{options.durationServiceDescription}</p>
      </div>
    </div>
  )

  const _renderWorkStandard = () => (
    <div className="description-detail-work">
      <h4 className="h4">{options.workStandardTitle}</h4>
      {options.workStandardDescription.map(item => (
        <div key={item.id} className="sub-description-detail-work">
          <img
            src={checkIcon}
            alt="halojasa/check-icon"
            className="icon-images"
          />
          <p key={item.id}>{item.title}</p>
        </div>
      ))}
    </div>
  )

  const _renderDescriptionArray = () =>
    options.descriptionService.map((item, index) => (
      <div style={{ marginTop: index > 0 ? 10 : 0 }} key={item.id}>
        <p>{item.title}</p>
        <p>{item.description}</p>
      </div>
    ))

  const _renderDescription = () => (
    <div className="description-detail-work">
      <h4 className="h4">{options.titleService}</h4>
      {Array.isArray(options.descriptionService) ? (
        _renderDescriptionArray()
      ) : (
        <p>{options.descriptionService}</p>
      )}
    </div>
  )

  const _renderArrayAlertCard = content => (
    <div>
      {content.map((item, index) => (
        <p style={{ marginTop: index > 0 ? 10 : 0 }} key={index}>
          {item}
        </p>
      ))}
    </div>
  )

  const _renderAlertCard = (content = '') => (
    <div className="alert-card">
      <img src={infoIcon} alt="halojasa/info-icon" className="icon-images" />
      {Array.isArray(content) ? (
        _renderArrayAlertCard(content)
      ) : (
        <p>{content}</p>
      )}
    </div>
  )

  const renderDetailWork = () => (
    <div className="container-detail-work">
      {_renderAlertCard(options.alertCard)}
      {_renderDescription()}
      {_renderWorkStandard()}
      {_renderAlertCard(options.secondAlertCard)}
      {_renderDuration()}
      {_renderCoverage()}
      {_renderStandardEquiment()}
      {_renderTermsOfService()}
    </div>
  )

  return (
    <Style
      className="card-long-box"
      hover={hover}
      padding={padding}
      imageAuto={imageAuto}
      shadow={shadow}
      border={border}
      imageSize={imageSize}
    >
      <div className="container-item">
        <img
          src={options.image}
          alt="halojasa/options-icon"
          className="card-long-image glass-hover"
        />
        <div className="text">
          <h4 className="h4">{options.title}</h4>
          <p>{options.description}</p>
          <div
            onClick={() => onPressDetailWork()}
            className="container-work-detail"
          >
            <div className="h4-black">Detail Pengerjaan</div>
            <div className="read-more-work-detail">
              <div className="h4-orange">Baca Selengkapnya</div>
              <img
                src={chevronRight}
                alt="halojasa/chevron-right"
                className="icon-image glass-hover"
              />
            </div>
          </div>
        </div>
      </div>
      {showDetailWork &&
        options.shouldShowDetailWorkContent &&
        renderDetailWork()}
    </Style>
  )
}

export default PremiumMassageItem
